import { Link, useParams } from "react-router-dom";
import Brand from "@/components/Brand";
import { ArrowLeft } from "lucide-react";

const CONTENT = {
  terms: {
    title: "Kullanım Koşulları",
    subtitle: "Son güncelleme: 04 Şubat 2026",
    body: `1. TARAFLAR
Bu sözleşme, https://smskapida.online (bundan sonra "SmsKapıda" olarak anılacaktır) ile siteye kayıt olan kullanıcı ("Kullanıcı") arasında düzenlenmiştir.

2. HİZMETİN TANIMI
SmsKapıda, kullanıcılarına dijital doğrulama hizmeti sunar. Kullanıcılar, sitede satın aldıkları bakiye ile kısa süreli SMS doğrulama numarası kiralayabilirler. Hizmet tamamen dijitaldir; fiziksel ürün gönderimi yoktur.

3. HESAP AÇMA VE KULLANIM
3.1. Kullanıcı, kayıt sırasında verdiği bilgilerin doğruluğunu taahhüt eder.
3.2. Hesap bilgileri kişisel olup, üçüncü kişilerle paylaşılamaz.
3.3. Kullanıcı, hesabından yapılan tüm işlemlerden sorumludur.

4. YASAK KULLANIM
Kullanıcı, satın aldığı numaraları aşağıdaki amaçlarla kullanamaz:
• Yasa dışı faaliyetler, dolandırıcılık, spam
• Üçüncü şahısların kişisel haklarına saldırı
• Terör, uyuşturucu, kumar veya çocuk istismarı gibi yasa dışı içeriklerle ilgili platformlarda kayıt
• Türk Ceza Kanunu ile yasaklanmış diğer eylemler

Bu tür kullanım tespit edildiğinde hesap kalıcı olarak kapatılır ve yasal yollar başvurulabilir.

5. FİYAT VE ÖDEME
5.1. Numara fiyatları anlık olarak sağlayıcı fiyatlarına göre belirlenir.
5.2. Ödeme yöntemleri: Havale/EFT (IBAN), Kripto para (USDT TRX/BTC/ETH), Kredi/Banka Kartı.
5.3. Bakiye Türk Lirası (₺) olarak hesaba yansıtılır.

6. İADE POLİTİKASI
Detaylı iade koşulları için "İade ve İptal Politikası" sayfasını inceleyiniz. Özet:
• SMS kodu alınmayan numaralarda 20. dakikada otomatik iade
• Kullanıcı 4. dakikadan sonra manuel iptal edip iade alabilir
• SMS kodu geldikten sonra iade yapılmaz

7. SORUMLULUK SINIRI
SmsKapıda, üçüncü taraf sağlayıcılara (Grizzly, SMS-Activate, 5sim vb.) bağımlı olduğu için sağlayıcı kaynaklı gecikme veya hizmet kesintilerinden sorumlu değildir. Bu tür durumlarda otomatik iade sistemi devreye girer.

8. DEĞİŞİKLİKLER
SmsKapıda, bu koşulları önceden haber vermeksizin değiştirme hakkını saklı tutar. Güncel koşullar site üzerinden yayınlanır.

9. UYGULANACAK HUKUK VE YETKİLİ MAHKEME
Bu sözleşmeden doğan uyuşmazlıklarda Türkiye Cumhuriyeti kanunları uygulanır. İstanbul Mahkemeleri ve İcra Daireleri yetkilidir.

İletişim: Telegram @smskapida`,
  },
  privacy: {
    title: "Gizlilik Politikası",
    subtitle: "Son güncelleme: 04 Şubat 2026",
    body: `1. GENEL
SmsKapıda olarak kullanıcılarımızın gizliliğine büyük önem veriyoruz. Bu politika, kişisel verilerinizin nasıl toplandığını, kullanıldığını ve korunduğunu açıklar.

2. TOPLANAN VERİLER
2.1. Kayıt sırasında: ad, soyad, kullanıcı adı, e-posta adresi, şifre (şifrelenmiş olarak saklanır — bcrypt).
2.2. Kullanım sırasında: aldığınız numara kayıtları, bakiye işlemleri, IP adresi, tarayıcı bilgisi.
2.3. Ödeme sırasında: ödeme yöntemi tercihi ve işlem referansı (kart bilgileri asla sitemizde saklanmaz — direkt ödeme sağlayıcıya iletilir).

3. VERİLERİN KULLANIM AMACI
• Hizmetin sunulması ve iyileştirilmesi
• Bakiye ve işlem geçmişinin takibi
• Yasal yükümlülüklerin yerine getirilmesi
• Kullanıcıya bildirim ve destek gönderilmesi

4. VERİ PAYLAŞIMI
Kişisel verileriniz sadece aşağıdaki durumlarda ve minimum düzeyde paylaşılır:
• SMS sağlayıcılarla (numara sağlama amaçlı, e-posta veya isim paylaşılmaz)
• Ödeme sağlayıcılarla (sadece ödeme işleminin gerçekleşmesi için)
• Yasal zorunluluk halinde yetkili mercilerle

Verileriniz reklam veya pazarlama amaçlı ÜÇÜNCÜ ŞAHISLARA SATILMAZ.

5. VERİ SAKLAMA SÜRESİ
Hesap aktif olduğu sürece veriler saklanır. Hesap silme talebiniz durumunda 30 gün içinde silinir. Yasal saklama zorunluluğu olan finansal kayıtlar 10 yıl saklanır.

6. GÜVENLİK
• Şifreler bcrypt ile hash'lenerek saklanır (düz metin şifre saklanmaz)
• Kart bilgileri sitemize gelmez, Shopier/Iyzico güvenli ödeme sayfasında girilir
• Sunucular SSL/TLS ile şifrelenmiş bağlantı üzerinden çalışır

7. ÇEREZLER (COOKIES)
Sitemiz, oturum açık tutma amaçlı localStorage kullanır. Reklam veya izleme çerezleri kullanılmaz.

8. HAKLARINIZ (KVKK)
• Verilerinize erişme
• Düzeltilmesini isteme
• Silinmesini isteme
• Aktarımına itiraz etme

Bu haklarınızı kullanmak için: Telegram @smskapida

9. GÜNCELLEMELER
Politikada değişiklik olursa güncel versiyon burada yayınlanır. Önemli değişikliklerde e-posta ile bilgilendirme yapılır.`,
  },
  kvkk: {
    title: "KVKK Aydınlatma Metni",
    subtitle: "6698 sayılı Kişisel Verilerin Korunması Kanunu kapsamında",
    body: `VERİ SORUMLUSU
SmsKapıda platformu (https://smskapida.online) veri sorumlusu sıfatıyla hareket etmektedir.

İŞLENEN KİŞİSEL VERİLER
• Kimlik verileri: Ad, soyad, kullanıcı adı
• İletişim verileri: E-posta adresi, opsiyonel telefon
• İşlem güvenliği verileri: IP adresi, oturum bilgileri, tarayıcı bilgisi
• Finansal veriler: Bakiye, işlem geçmişi, ödeme referansları

İŞLEME AMAÇLARI
• Üyelik oluşturma ve yönetimi
• Hizmet sunumu ve müşteri ilişkileri yönetimi
• Yasal ve idari yükümlülüklerin yerine getirilmesi
• Güvenliğin sağlanması ve dolandırıcılık tespiti
• İstatistiksel analiz ve hizmet iyileştirme

İŞLEMENİN HUKUKİ SEBEBİ
• Kullanıcı ile aramızdaki sözleşme (KVKK m.5/2-c)
• Meşru menfaat (KVKK m.5/2-f)
• Yasal yükümlülük (KVKK m.5/2-ç)

AKTARIM
Kişisel verileriniz, yalnızca hizmetin sağlanabilmesi için gerekli olduğunda ve KVKK'ya uygun şekilde:
• Yurt içi/yurt dışı SMS sağlayıcılara (Grizzly SMS, SMS-Activate, 5sim)
• Ödeme kuruluşlarına (Shopier, Iyzico vb.)
• Yasal zorunluluk halinde yetkili kamu kurumlarına aktarılır.

YURT DIŞI AKTARIM
Bazı SMS sağlayıcılarımızın sunucuları yurt dışında yer aldığından, kullanıcı bilgileri (özellikle numara talep bilgisi) yurt dışına aktarılır. Bu aktarım için açık rızanız KVKK m.9/1 kapsamında alınmıştır (kayıt olurken).

HAKLARINIZ (KVKK MADDE 11)
Veri sorumlusuna başvurarak;
a) İşlenip işlenmediğini öğrenme
b) İşlenmişse bilgi talep etme
c) İşleme amacını öğrenme ve amacına uygun kullanılıp kullanılmadığını öğrenme
d) Yurt içinde/dışında aktarıldığı üçüncü kişileri bilme
e) Eksik/yanlış işlenmesi halinde düzeltilmesini isteme
f) Silme veya yok edilmesini isteme
g) İşlenen verilerin ortaya çıkardığı sonuca itiraz etme
h) Kanuna aykırı işlenme nedeniyle zarara uğramanız halinde tazminat talep etme
haklarına sahipsiniz.

BAŞVURU YOLLARI
• Telegram: @smskapida
• Sitemizde bulunan iletişim formu

Başvurularınız 30 gün içinde yanıtlanır.`,
  },
  refund: {
    title: "İade ve İptal Politikası",
    subtitle: "Şeffaf, otomatik ve adil iade sistemi",
    body: `1. GENEL PRENSİP
SmsKapıda'da satın alınan her numara için OTOMATİK İADE GARANTİSİ bulunmaktadır. Ödemenizi güvenle yapabilirsiniz.

2. İADE KOŞULLARI

A) OTOMATİK İADE (20. Dakika)
Aldığınız numaraya 20 dakika içinde SMS kodu gelmezse, ödediğiniz tutarın TAMAMI otomatik olarak site içi bakiyenize iade edilir. Ekstra bir işlem yapmanıza gerek yoktur; sistem otomatik olarak bakiyenize aktarır.

B) MANUEL İPTAL & İADE (4. Dakika Sonrası)
Numara aldıktan sonra 4. dakikadan itibaren "İptal & İade" butonu aktifleşir. Butona basıldığında:
• Numara sağlayıcı tarafında iptal edilir
• Ödediğiniz tutar anında bakiyenize iade edilir
• İptal işlemi geri alınamaz

Neden 4 dakika? SMS sağlayıcıları, numaranın satın alındıktan hemen sonra iptal edilmesini kabul etmez (2 dakikalık minimum bekleme). 4 dakika, hem sağlayıcı kısıtlamasını aşan hem de kullanıcıya makul süre veren bir sınırdır.

C) SMS KODU GELDİKTEN SONRA (İADE YAPILMAZ)
SMS doğrulama kodu numaraya ulaştıktan sonra iade yapılmaz. Sebebi: numarayı satın aldığınız servis (WhatsApp, Google, Telegram vb.) doğrulamayı tamamladığından hizmet teslim edilmiş sayılır.

3. BAKİYE İADESİ
İade tutarı Türk Lirası (₺) olarak site içi bakiyenize eklenir. Bu bakiye ile:
• Yeni numara satın alabilirsiniz
• Farklı bir servis/ülke deneyebilirsiniz
• Bakiye limiti dolduysa banka iadesi için Telegram destek üzerinden başvurabilirsiniz

4. BANKA/KART İADESİ
Kartla veya IBAN ile yaptığınız ödemenin BANKANIZA iadesi için:
• Telegram destek (@smskapida) üzerinden talebinizi iletin
• Ödeme referansınızı belirtin
• Talebiniz onaylanırsa, banka hesabınıza 5-10 iş günü içinde yansır (ödeme sağlayıcısına bağlı)

Not: Bakiyenizden yaptığınız satın alma işlemleri kullanılmışsa, kullanılan kısım için banka iadesi mümkün olmayabilir.

5. SAĞLAYICI KAYNAKLI PROBLEMLER
Sağlayıcı sunucularında yaşanan geçici kesintiler veya hatalar durumunda:
• Numara verilmediyse: bakiye anında iade edilir
• Numara verildi ama SMS gelmediyse: 20 dakikada otomatik iade
• Beklenmedik durumlar: Telegram destek üzerinden çözüm sağlanır

6. YASAK KULLANIM DURUMU
Kullanım koşullarına aykırı hareket eden kullanıcılar için:
• Hesap kalıcı olarak kapatılır
• Bakiye iade edilmez (hizmet suistimali kapsamında)
• Gerekli yasal işlemler başlatılır

7. İLETİŞİM
İade veya iptalle ilgili sorularınız için:
• Telegram: @smskapida
• Sitemizden "Alınanlar" sayfası üzerinden numara bazlı iptal

SMS Kapıda'yı tercih ettiğiniz için teşekkür ederiz.`,
  },
};

export default function Legal() {
  const { doc } = useParams();
  const c = CONTENT[doc] || CONTENT.terms;

  return (
    <div className="min-h-screen brand-bg text-white">
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-black/50 border-b border-white/10">
        <div className="max-w-4xl mx-auto flex items-center justify-between px-5 md:px-6 h-16">
          <Link to="/"><Brand size="sm" /></Link>
          <Link to="/" className="text-xs text-white/60 hover:text-white transition-colors inline-flex items-center gap-1.5" data-testid="legal-back">
            <ArrowLeft className="w-3.5 h-3.5" /> Ana Sayfa
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-5 md:px-6 py-12 md:py-16">
        <div className="mb-8">
          <div className="text-[10px] uppercase tracking-[0.3em] text-white/40 mb-2">Yasal Bilgiler</div>
          <h1 className="font-display font-black text-3xl md:text-5xl leading-tight mb-3" data-testid="legal-title">{c.title}</h1>
          <p className="text-white/50 text-sm">{c.subtitle}</p>
        </div>

        <div className="border border-white/10 bg-[hsl(220,40%,9%)] rounded-2xl p-6 md:p-8">
          <pre className="whitespace-pre-wrap font-sans text-white/80 text-sm md:text-base leading-relaxed" data-testid="legal-body">
{c.body}
          </pre>
        </div>

        <div className="mt-8 flex flex-wrap gap-2 text-xs">
          <LegalLink to="/legal/terms" active={doc === "terms"}>Kullanım Koşulları</LegalLink>
          <LegalLink to="/legal/privacy" active={doc === "privacy"}>Gizlilik Politikası</LegalLink>
          <LegalLink to="/legal/kvkk" active={doc === "kvkk"}>KVKK</LegalLink>
          <LegalLink to="/legal/refund" active={doc === "refund"}>İade Politikası</LegalLink>
        </div>
      </main>
    </div>
  );
}

function LegalLink({ to, active, children }) {
  return (
    <Link to={to} className={`px-3 py-1.5 rounded-full border transition-colors ${
      active
        ? "bg-[hsl(43,74%,55%)]/15 border-[hsl(43,74%,55%)]/60 text-[hsl(43,74%,68%)]"
        : "border-white/10 text-white/60 hover:border-white/25 hover:text-white"
    }`}>
      {children}
    </Link>
  );
}
